import { InjectionToken } from '@angular/core';
import { LoginResponse } from 'lib-klab-core';

export type AppKind = 'customers' | 'admin';

export type IamRoleId = number;
export type IamRoleName = string;
export type PermissionCode = string;

export interface AuthUiConfig {
    appKind?: AppKind;
    canAccessPortal?: (session: LoginResponse) => boolean;

    postLoginRedirectUrl: string;

    storageTokenKey: string;

    loginUrl?: string;
    forbiddenRedirectUrl?: string;

    access?: {
        allowedRoleIds?: IamRoleId[];
        allowedRoleNames?: IamRoleName[];
        requiredAnyPermissions?: PermissionCode[];
    };

    redirectByRoleId?: Record<IamRoleId, string>;
    redirectByRoleName?: Record<IamRoleName, string>;

    redirectByPermission?: Record<PermissionCode, string>;

    resolveRedirect?: (session: LoginResponse) => string | null | undefined;
}

export const AUTH_UI_CONFIG = new InjectionToken<AuthUiConfig>('AUTH_UI_CONFIG');
